import React, {useState, useEffect} from "react"
import PuzzleIntro from "./PuzzleIntro"
import PuzzleContent from "./puzzleContent/PuzzleContent"
import SuspectKeypad from "./suspectKeypad/SuspectKeypad"
import headerData from "../header/headerData"
import DownloadModule from "./downloadModule/DownloadModule"

function MainSection(props) {
    const barColor = headerData[props.currentPage].color
    const breakBar = <div className={"colourStripe " + barColor} />
    const [barClicked, setBarClicked] = useState(false)
    const [finalPart] = useState(5)
    const [keypadUnlock, setKeypadUnlock] = useState("")
    
    useEffect(() => {
        if (props.partStatus[props.currentPage].status === "complete") {
            unlockKeypad()
        } else {
            setKeypadUnlock(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.currentPage])
    
    useEffect(() => {
        
    }, [keypadUnlock])
    
    function unlockPartFour() {
        props.currentPage === 4 ? setBarClicked(true) : setBarClicked(false)
        props.callBackGameUpdate()
    }
        
    function unlockKeypad() {
        setKeypadUnlock(true)
    }
    
    const suspectModule = <SuspectKeypad currentPage={props.currentPage} callBack={props.callBackPage} keypadUnlock={keypadUnlock} callBackPartComplete={props.callBackPartComplete} partStatus={props.partStatus}/>
        
    return (
        <main>
            <PuzzleIntro currentPage={props.currentPage} />
        
            {breakBar}
        
            {props.currentPage > 1 ? <DownloadModule unlockPartFour={unlockPartFour} barColor={barColor} currentPage={props.currentPage} handleDownload={props.handleDownload} playerPrint={props.playerPrint} /> : ""}
        
            <PuzzleContent currentPage={props.currentPage} barClicked={barClicked} callBackPage={props.callBackPage} callBackKeypad={unlockKeypad} callBackGameUpdate={props.callBackGameUpdate} timeLimit={props.timeLimit} callBackRevealClues={props.callBackRevealClues} partStatus={props.partStatus}/>
        
            {breakBar}
        
            {props.currentPage < finalPart ? suspectModule : ""}
            
            <div id="mainCornerCut"></div>
        </main>
    )
}

export default MainSection